export default {
  BT_HDP: "Handicap",
  BT_OU: "Besar/Kecil",
  BT_ML: "Moneyline",
  BT_1X2: "1X2",
  BT_1X2HDP: "Handicap 3 arah",
  BT_CS: "Skor Yang Tepat",
  BT_OE: "Ganjil/Genap",
  BT_DC: "Peluang Ganda",
  BT_HTFT: "Babak Pertama/Waktu Penuh",
  BT_FGLG: "Gol Pertama/Gol Terakhir",
  BT_TG: "Total Gol",
  BT_OR: "Outright",
  BT_ORZ: "Outright",
  BT_ODD: "Ganjil",
  BT_EVEN: "Genap",

  BT_ANB: "Away No Bet",
  BT_BS: "Keduanya/Salah Satu/Tidak Satu Pun mencetak skor",
  BT_CL: "Catatan Bersih",
  BT_DNB: "Taruhan Tanpa Seri",
  BT_DNB: "1H. Taruhan Tanpa Seri",
  BT_HNB: "Home No Bet",
  BT_TWTN: "Menang Tanpa Kebobolan Gol",

  BT_HDPH: "1H. Handicap",
  BT_OUH: "1H. Besar/Kecil",
  BT_MLH: "1H. Moneyline",
  BT_1X2H: "1H. 1X2",
  BT_1X2HDPH: "1H. Handicap 3 arah",
  BT_CSH: "1H. Skor Yang Tepat",
  BT_OEH: "1H. Ganjil/Genap",
  BT_DCH: "1H. Peluang Ganda",
  BT_FGLGH: "1H. Gol Pertama/Gol Terakhir",
  BT_TGH: "1H. Total Gol",

  TB_HDP: "FT. HDP",
  TB_OU: "FT. O/U",
  TB_1X2: "FT. 1X2",
  TB_OE: "FT. Ganjil/Genap",
  TB_HDPH: "1H. HDP",
  TB_OUH: "1H. O/U",
  TB_1X2H: "1H. 1X2",
  TB_OEH: "1H. Ganjil/Genap",

  BT_HDPOU: "HDP & OU",
  BT_PARLAY: "Taruhan Campuran",
  BT_FT: "Waktu Penuh",
  BT_1H: "Babak Pertama",
  BT_2H: "Babak Kedua",

  BT_FG: "Gol Pertama",
  BT_LG: "Gol Terakhir",
  BT_HFG: "Tim Kandang Gol Pertama",
  BT_AFG: "Tim Tandang Gol Pertama",
  BT_HLG: "Tim Kandang Gol Terakhir",
  BT_ALG: "Tim Tandang Gol Terakhir",
  BT_NG: "Tidak Ada Gol",
  BT_HY: "Tim Kandang Ya",
  BT_HN: "Tim Kandang Tidak",
  BT_AY: "Tim Tandang Ya",
  BT_AN: "Tim Tandang Tidak",
  BT_H: "Tim Kandang",
  BT_A: "Tim Tandang",
  BT_D: "Seri",
  BT_HD_DC: "Tim Kandang atau Seri",
  BT_HA_DC: "Tim Kandang atau Tim Tandang",
  BT_DA_DC: "Tim Tandang atau Seri",
  BT_HH: "Tim Kandang/Tim Kandang",
  BT_HD: "Tim Kandang/Seri",
  BT_HA: "Tim Kandang/Tim Tandang",
  BT_DH: "Seri/Tim Kandang",
  BT_DD: "Seri/Seri",
  BT_DA: "Seri/Tim Tandang",
  BT_AH: "Tim Tandang/Tim Kandang",
  BT_AD: "Tim Tandang/Seri",
  BT_AA: "Tim Tandang/Tim Tandang",

  BT_Y: "Ya",
  BT_N: "Tidak",

  BT_LIVE: "LANGSUNG",
  BT_HT: "H.Time",
  BT_DELAYED: "Menunda",
  BT_PEN: "PEN",

  BT_FT1: "FT.1",
  BT_FT2: "FT.2",
  BT_FTX: "FT.X",

  TC_FT1: "1",
  TC_FT2: "2",
  TC_FTX: "X",

  BT_HT1: "HT.1",
  BT_HT2: "HT.2",
  BT_HTX: "HT.X",

  F5_INN_HDP: "F5 INN. HDP",
  F5_INN_OU: "F5 INN. O/U",

  BS_HDP: "FT Handicap",
  BS_HDPH: "FH Handicap",
  BS_OU: "FT. Besar/Kecil",
  BS_OUH: "FH. Besar/Kecil",
  BS_OE: "FT. Ganjil/Genap",
  BS_OEH: "FH. Ganjil/Genap",
  BS_1X2: "FT. 1X2",
  BS_1X2H: "FH 1X2",
  BS_ML: "FT Moneyline",
  BS_MLH: "FH Moneyline",
  BS_1X2HDP: "FT. Handicap 3 arah",
  BS_1X2HDPH: "FH. Handicap 3 arah",
  BS_CS: "FT. Skor Yang Tepat",
  BS_CSH: "FH. Skor Yang Tepat",
  BS_DC: "FT. Peluang Ganda",
  BS_DCH: "FH. Peluang Ganda",
  BS_FGLG: "FT. Gol Pertama/Gol Terakhir",
  BS_FGLGH: "FH. Gol Pertama/Gol Terakhir",
  BS_TG: "FT. Total Gol",
  BS_TGH: "FH. Total Gol",
  BS_ANB: "Away No Bet",
  BS_HTFT: "Babak Pertama/Waktu Penuh",
  BS_BS: "Keduanya/Salah Satu/Tidak Satu Pun mencetak skor",
  BS_CL: "Catatan Bersih",
  BS_DNB: "Taruhan Tanpa Seri",
  BS_DNBH: "FH Taruhan Tanpa Seri",
  BS_HNB: "Home No Bet",
  BS_TWTN: "Menang Tanpa Kebobolan Gol",
  BS_OR: "Outright",
  BS_ORZ: "Outright",
}